import React, { Component } from 'react';

class InnerFeatureButtonGroup extends Component {

	render() {
		return (
			<div>
				<div style={{float: 'right', marginTop: '15px'}}>
					{this.props.children}
				</div>
			</div>
		)
	}
}

export default InnerFeatureButtonGroup;



// WEBPACK FOOTER //
// ./src/content/InnerFeatureButtonGroup.js